export default {
  // 画布类型
  multiCurrencyCanvas: "多币种画布",

  // 画布名称
  unnamedCanvas: "未命名画布",

  // 案件名称
  caseName: "案件：",

  // 搜索框
  searchPlaceholder: "搜索地址 / 哈希 / 调证用户ID",

  // 按钮
  startAnalysis: "开始分析",
  switchToOldVersion: "切到老版本",
  expandConfig: "扩展配置",
  refresh: "刷新",
  shareCanvas: "分享画布",
  save: "保存",

  // 工具提示
  expandOrCollapseConfig: "展开或收起扩展配置项",

  // 下拉菜单
  surveyDataUpdate: "调证数据更新",
  labelUpdate: "标签更新",
  noteUpdate: "备注更新",
  addressBalanceUpdate: "地址余额更新",
  lastUpdate: "上次更新：",

  // 对话框
  dialogTitle: "提示",
  balanceUpdateMessage:
    "当前画布地址共{count}个，更新余额需要较长的时间，请耐心等待！",
  cancel: "取 消",
  confirm: "确 定",

  // 货币选项
  allCurrencies: "全部",
};
